<template>
  <div class="loading" v-if="isShow.isLDShow">
    <div class="ld-bg2">
      <img id="loadingBgPic" src="./img/bg.jpg" v-show="loadingBg" />
    </div>
    <div class="ld-bg">
      <img src="./img/0.png" /><img src="./img/1.png" /><img
        src="./img/2.png"
      /><img src="./img/3.png" /><img src="./img/4.png" /><img
        src="./img/5.png"
      /><img src="./img/6.png" /><img src="./img/7.png" /><img src="./img/8.png" /><img src="./img/9.png" />
      <img src="./img/10.png" /><img src="./img/11.png" /><img
        src="./img/12.png"
      /><img src="./img/13.png" /><img src="./img/14.png" /><img
        src="./img/15.png"
      /><img src="./img/16.png" /><img src="./img/17.png" /><img src="./img/18.png" /><img src="./img/19.png" />
      <img src="./img/20.png" /><img src="./img/21.png" /><img
        src="./img/22.png"
      /><img src="./img/23.png" /><img src="./img/24.png" /><img
        src="./img/25.png"
      /><img src="./img/26.png" /><img src="./img/27.png" /><img src="./img/28.png" /><img src="./img/29.png" />
      <img src="./img/30.png" /><img src="./img/31.png" /><img
        src="./img/32.png"
      />
    </div>
    <div class="loadingWen">
    <div class="progress-bar-wp">
      <div class="progress-text">{{ loadingNum }}%</div>
      <div class="loadingTxt"></div>
    </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Loading",
  props: {
    isShow: Object,
  },
  data() {
    return {
      loadingNum: 0,
      loadingBg:false,
      preLoadImg: [
        { src: require("../../components/musicplayer/img/music-off.png") },
        { src: require("../../components/musicplayer/img/kg_kg_00.png") },
        { src: require("../../components/musicplayer/img/kg_kg_01.png") },
        { src: require("../../components/musicplayer/img/kg_kg_02.png") },
        { src: require("../../components/musicplayer/img/kg_kg_03.png") },
        { src: require("../../components/musicplayer/img/kg_kg_04.png") },
        { src: require("../../components/musicplayer/img/kg_kg_05.png") },
        { src: require("../../components/musicplayer/img/kg_kg_06.png") },
        { src: require("../../components/musicplayer/img/kg_kg_07.png") },
        { src: require("../../components/musicplayer/img/kg_kg_08.png") },
        { src: require("../../components/musicplayer/img/kg_kg_09.png") },
        { src: require("../../components/musicplayer/img/kg_kg_10.png") },
        { src: require("../../components/musicplayer/img/kg_kg_11.png") },
        { src: require("../../components/musicplayer/img/kg_kg_12.png") },
        { src: require("../../components/musicplayer/img/kg_kg_13.png") },
        { src: require("../../components/musicplayer/img/kg_kg_14.png") },
        { src: require("../../components/musicplayer/img/kg_kg_15.png") },
        { src: require("../../components/musicplayer/img/kg_kg_16.png") },
        { src: require("../../components/musicplayer/img/kg_kg_17.png") },
        { src: require("../../components/musicplayer/img/kg_kg_18.png") },
        { src: require("../../components/musicplayer/img/kg_kg_19.png") },
        { src: require("../../components/musicplayer/img/kg_kg_20.png") },
        { src: require("../../components/musicplayer/img/kg_kg_21.png") },
        { src: require("../../components/musicplayer/img/kg_kg_22.png") },
        { src: require("../../components/musicplayer/img/kg_kg_23.png") },
        { src: require("../../components/musicplayer/img/kg_kg_24.png") },
        { src: require("../../components/ispc/img/ewm.jpg") },
        { src: require("./../page-kv/img/bg.jpg") },
        { src: require("./../page-kv/img/p1-1.png") },
        { src: require("./../page-kv/img/p1-2-0.png") },
        { src: require("./../page-kv/img/p1-2-1.png") },
        { src: require("./../page-kv/img/p1-2-2.png") },
        { src: require("./../page-kv/img/p1-2-3.png") },
        { src: require("./../page-kv/img/p1-2.png") },
        { src: require("./../page-kv/img/p1-3-0.png") },
        { src: require("./../page-kv/img/p1-3-1.png") },
        { src: require("./../page-kv/img/p1-3.png") },
        { src: require("./../page-kv/img/p1-4.png") },
        { src: require("./../page-kv/img/p1-4-0.png") },
        { src: require("./../page-kv/img/p1-4-1.png") },
        { src: require("./../page-kv/img/p1-a-1.png") },
        { src: require("./../page-kv/img/p1-a-2.png") },
        { src: require("./../page-kv/img/p1-r-0.png") },
        { src: require("./../page-kv/img/p1-r-1.png") },
        { src: require("./../page-kv/img/p1-t0.png") },
        { src: require("./../page-kv/img/p1-t1.png") },
        { src: require("./../page-kv/img/p1-t2.png") },
        { src: require("./../page-kv/img/p1-t3.png") },
        { src: require("./../page-kv/img/p1-t4.png") },
        { src: require("./../page-kv/img/p1-t5.png") },
        { src: require("./../page-kv/img/p1-t6.png") },
        { src: require("./../page-kv/img/p1-t7.png") },
        { src: require("./../page-kv/img/p1-t8.png") },
        { src: require("./../page-kv/img/p1-t9.png") },
        { src: require("./../page-kv/img/p1-t10.png") },
        { src: require("./../page-kv/img/p1-t11.png") },
        { src: require("./../page-kv/img/p1-t12.png") },
        { src: require("./../page-kv/img/p1-liuxing0.png") },
        { src: require("./../page-kv/img/p1-liuxing1.png") },
        { src: require("./../page-kv/img/xk1.png") },//华丽的分割线
        { src: require('./../page-one/img/pbg.jpg') },
        { src: require('./../page-one/img/yhyren.png') },
        { src: require('./../page-one/img/jiqi-0.png') },
        { src: require('./../page-one/img/jiqi-0-0.png') },
        { src: require('./../page-one/img/jiqi-0-1.png') },
        { src: require('./../page-one/img/datikuang-0.png') },
        { src: require('./../page-one/img/datikuang-1.png') }
      ],
      timeOut: null,
    };
  },
  methods: {
    generateId(index) {
      return "mImg" + index;
    },
    go() {
      clearInterval(this.timeOut);

      let data = {
        para: "isKVShow",
      };
      this.$emit("nextPage", data);
    },
    loadNextImg(imgID) {
      const _this = this;
      const len = this.preLoadImg.length;
      const curSrc = this.preLoadImg[imgID].src;
      let curImg = new Image();
      curImg.onload = function () {
        imgID++;
        _this.loadingNum = parseInt((imgID / len) * 100);
        if (imgID < len) {
          _this.loadNextImg(imgID);
        } else {
          _this.go()
        }
      };
      curImg.src = curSrc;
    },
  },
  mounted() {
    let _this=this
    document.getElementById("loadingBgPic").onload=function(){
      _this.loadingBg=true
    }


    let imgID = 0;
    setTimeout(() => {
      this.loadNextImg(imgID);
    }, 1000);

    let i = 0;
    this.timeOut = setInterval(() => {
      $(".ld-bg img").hide()
      $(".ld-bg img").eq(i).show()
      i++;
      if (i > 32) {
        i = 0;
      }
    }, 300);
  },
};
</script>

<style lang="less" scoped>
.bg(@url) {
  background-size: 100% auto;
  background-image: url(@url);
  background-repeat: no-repeat;
  background-position: center bottom;
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100vw;
  height: 100vh;
  .bg("./img/bg0.jpg");
}
.loadingWen{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}

.ld-bg2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  img {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.ld-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  // background-position: center bottom;
  // .bg("./img/bg.jpg");

  img {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.progress-bar-wp{
  padding-top: 12vh;
}

.progress-text {
  text-align: center;
  color: #5ba8ff;
  font-size: 0.75rem /* 12/16 */;
  line-height: 1.4;
}

.loadingTxt {
  width: (16.875rem/2) /* 270/16 */;
  height: (6.625rem/2) /* 106/16 */;
  .bg("./img/txt.png");
  margin-top: 1.5rem;
}

@media only screen and (device-width: 414px) and (device-height: 736px) {
}
</style>



// WEBPACK FOOTER //
// src/pages/loading/loading.vue